import React, { useEffect } from "react";
import "./wishlist.scss";
import { Button, Grid, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import WishlistCard from "../../components/wishlistCard/WishlistCard";
import wishlistStore from "../../store/wishlistStore";
import WishlistCardSkeleton from "../../components/wishlistCard/WishlistCardSkeleton";

const Wishlist = () => {
  const navigate = useNavigate();
  const WishlistStore = wishlistStore();
  const isMobile = useMediaQuery("(max-width: 420px)");

  const wishlistLoading = [1, 2, 3, 4];

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="wishlist">
      {WishlistStore.isLoading ? (
        <>
          <div className="title">Quick Look</div>
          <Grid
            container
            className="content-container"
            spacing={isMobile ? 1.2 : 2}
          >
            {wishlistLoading.map((item) => (
              <Grid
                item
                lg={2}
                md={3}
                sm={4}
                xs={6}
                className="single-view"
                key={item}
              >
                <WishlistCardSkeleton />
              </Grid>
            ))}
          </Grid>
        </>
      ) : WishlistStore.wishlistProduct ? (
        <>
          <div className="title">Quick Look</div>
          <Grid
            container
            className="content-container"
            spacing={isMobile ? 1.2 : 2}
          >
            {WishlistStore.wishlistProduct
              .slice(0)
              .reverse()
              .map((item) => (
                <Grid
                  item
                  lg={2}
                  md={3}
                  sm={4}
                  xs={6}
                  className="single-view"
                  key={item._id}
                >
                  <WishlistCard item={item} />
                </Grid>
              ))}
          </Grid>
        </>
      ) : (
        <div className="no-wishlist-product">
          <div className="no-wishlist-title">
            Your quick look is currently empty
          </div>
          <div className="sub-description">No product added to quick look</div>
          <div className="wishlist-btn-container">
            <Button
              className="btn"
              variant="contained"
              onClick={() => {
                navigate("/");
              }}
            >
              <p>Return to Shop</p>
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Wishlist;
